<template>
  <div ref="tablePage" style="height: 100%">
    <!-- 面包屑导航 -->
    <div class="topNav">
      <div class="navFormWrapper">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/homePage' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item :to="{ path: '/community/community' }"
            >小区管理</el-breadcrumb-item
          >
          <el-breadcrumb-item
            :to="{
              path: '/community/building',
              query: { id: lastId },
            }"
            >楼栋管理</el-breadcrumb-item
          >
          <el-breadcrumb-item>房间管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form
          style="margin-left: 8vh"
          ref="queryForm"
          :model="searchForm"
          inline
        >
          <el-form-item style="margin-bottom: 0">
            <el-input
              v-model="searchForm.title"
              autocomplete="off"
              maxlength="30"
              placeholder="房号"
              clearable
              size="mini"
              @change="searchChange"
            />
          </el-form-item>
          <el-form-item style="margin-bottom: 0">
            <el-input
              v-model="searchForm.mobile"
              autocomplete="off"
              maxlength="30"
              placeholder="电话号码"
              clearable
              size="mini"
              @change="searchChange"
            />
          </el-form-item>
          <el-form-item style="margin-bottom: 0">
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="searchChange"
              size="mini"
              >搜索</el-button
            >
            <el-button
              type="success"
              icon="el-icon-plus"
              @click="handleNewAdd"
              size="mini"
              >新增房间</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="batchDels"
              size="mini"
              >批量删除</el-button
            >
            <el-button
              type="info"
              icon="el-icon-download"
              @click="fileAdd"
              size="mini"
              >导入</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 分割 -->
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/community/community' }"
        >小区管理</el-breadcrumb-item
      >
      <el-breadcrumb-item
        :to="{
          path: '/community/building',
          query: { id: lastId },
        }"
        >楼栋管理</el-breadcrumb-item
      >
      <el-breadcrumb-item>房间管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form ref="queryForm" :model="searchForm" inline>
      <el-form-item label="房号">
        <el-input
          v-model="searchForm.title"
          autocomplete="off"
          maxlength="30"
          placeholder="请输入"
          clearable
          size="mini"
        />
      </el-form-item>
      <el-form-item label="电话号码">
        <el-input
          v-model="searchForm.mobile"
          autocomplete="off"
          maxlength="30"
          placeholder="请输入"
          clearable
          size="mini"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="searchChange"
          size="mini"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" @click="resets" size="mini"
          >重置</el-button
        >
      </el-form-item>
    </el-form>
    <el-button
      type="primary"
      icon="el-icon-plus"
      plain
      @click="handleNewAdd"
      size="mini"
      style="margin-top: 2vh"
      >新增房间</el-button
    >
    <el-button
      type="info"
      icon="el-icon-plus"
      plain
      @click="fileAdd"
      size="mini"
      style="margin-top: 2vh"
      >导入</el-button
    > -->
    <el-table
      :data="tableList"
      style="width: 100%; margin-top: 2vh"
      @selection-change="handleSelectionChanges"
      border
      size="mini"
      :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
      }"
    >
      <el-table-column type="selection" width="55" align="center">
      </el-table-column>
      <el-table-column prop="building_name" label="楼栋" align="center" />
      <el-table-column prop="title" label="房号" align="center" />
      <el-table-column prop="realname" label="姓名" align="center" />
      <el-table-column prop="mobile" label="手机号" align="center" />
      <el-table-column prop="sms_status" label="状态" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.sms_status"
            :active-value="1"
            :inactive-value="0"
            @change="changesms_status(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="handleClick(scope.row)"
            type="primary"
            size="small"
          >
            修改信息
          </el-button>
          <el-button
            @click.native.prevent="singleDel(scope.row, scope.row.id)"
            type="danger"
            size="small"
          >
            移除房间
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="searchForm.page"
      :limit.sync="searchForm.size"
      @pagination="initList"
    />
    <el-dialog
      :title="title"
      :visible.sync="addOrEditOpen"
      :close-on-click-modal="false"
      width="30%"
      class="global-dialog-position"
      :before-close="getout"
    >
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="房号" prop="title">
              <el-input
                v-model="form.title"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="业主名称" prop="realname">
              <el-input
                v-model="form.realname"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="手机号" prop="mobile">
              <el-input
                v-model="form.mobile"
                autocomplete="off"
                placeholder="请输入"
                type="number"
              />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24">
            <el-form-item label="展示状态">
              <el-radio-group v-model="form.sms_status">
                <el-radio
                  v-for="item in regionTypes"
                  :label="item.label"
                  :key="item.label"
                  >{{ item.text }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForms">确 定</el-button>
        <el-button @click="getout">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 导入弹窗 -->
    <el-dialog
      :title="title"
      :visible.sync="importOpen"
      :close-on-click-modal="false"
      width="30%"
      class="global-dialog-position"
    >
      <div class="upload-container">
        <el-upload
          class="upload-demo"
          v-loading="diaIf"
          element-loading-text="拼命上传中"
          drag
          :action="uploadImgUrl"
          :headers="headers"
          :data="uploadParams"
          :name="'import_file'"
          :on-success="handleAvatarSuccess"
		  :on-error="handleUploadError"
          :show-file-list="false"
          :before-upload="onChange"
          multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
      </div>
    </el-dialog>
    <!-- 小程序码弹窗 -->
    <el-dialog
      :title="title"
      :visible.sync="appOpen"
      :close-on-click-modal="false"
      width="30%"
      class="global-dialog-position"
    >
      <el-image
        style="
          width: 100%;
          height: 50vh;
          display: flex;
          justify-content: center;
          align-items: center;
        "
        :src="appUrl"
        :preview-src-list="[appUrl]"
      >
        <div slot="error" class="image-slot">
          <div style="text-align: center; font-size: 24px">
            请生成二维码再查看！
          </div>
        </div>
      </el-image>
    </el-dialog>
  </div>
</template>
  
  <script>
import { getroomList, editRoom, addRoom, deleteRoom } from "../../api/room";
import tableCommon from "../../../mixins/table-common";
import { getCookie } from "../../utils/util";
export default {
  mixins: [tableCommon],
  data() {
    return {
      regionTypes: [
        {
          label: 1,
          text: "发送",
        },
        {
          label: 0,
          text: "拉黑",
        },
      ],
      api: {
        list: getroomList,
        add: addRoom,
        edit: editRoom,
        del: deleteRoom,
      },
      diaIf: false,
      uploadParams: {
        building_id: "",
      },
      // 导入导出弹窗
      importOpen: false,
      // 规则验证
      rules: {
        title: [{ required: true, message: "请输入房号", trigger: "blur" }],
        realname: [{ required: true, message: "请输入名称", trigger: "blur" }],
        mobile: [{ required: true, message: "请输入手机号", trigger: "blur" }],
      },
      // 传参
      form: {
        sms_status: "1",
        building_id: "",
      },
      // 弹窗标题
      title: "新增",
      addOrEditOpen: false,
      // 查询参数
      searchForm: {
        page: 1,
        size: 10,
      },
      // 列表数据
      tableList: [],
      // 请求id
      id: "",
      // 分页
      total: 0,
      appOpen: false,
      // 小程序码
      appUrl: "",
      // 回传id
      lastId: "",
      // 上传头文件
      headers: {
        Authorization: "Bearer " + getCookie("logintoken"),
      },
      // 图片上传地址
      uploadImgUrl: process.env.VUE_APP_URL + "/admin/room/roomImport",
    };
  },
  mounted() {
    this.searchForm.building_id = this.$route.query.id;
    this.lastId = this.$route.query.lastId;
    this.uploadParams.building_id = this.$route.query.id;
    this.initList();
  },
  methods: {
    handleSelectionChanges(selection) {
      this.tableSelected = selection;
      this.ids = selection.map((item) => item[this.idKey]);
    },
    batchDels() {
      this.batchDel(this.ids);
    },
    async batchDel(idKeys, ...args) {
      const delFn = this.api.del;
      const text = args.length ? `是否删除这条数据` : `是否删除这条数据`;
      await this.$confirm(text, "删除数据", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        for (const idKey of idKeys) {
          const res = await delFn(idKey);
          if (res.code !== 200) {
            return this.$message.error(res.msg ? res.msg : "删除失败!");
          }
          // this.$message.success("删除成功");
          this.initList();
        }
      });
    },
    // 改变状态
    changesms_status(res) {
      this.form = JSON.parse(JSON.stringify(res));
      // this.handleEdit();
      this.actionType = "edit";
      this.form = JSON.parse(JSON.stringify(res));
      const { city_name, created_at, share_img, ...rest } = res;
      this.form = rest;
      editRoom(this.form).then((msg) => {
        if (msg.code !== 200) return this.$message("获取状态失败");
      });
    },
    // 上传时
    onChange() {
      this.diaIf = true;
    },
    // 上传成功
    handleAvatarSuccess(res) {
		if (res.code == 200) {
			if (res.data && res.data.code != 200) {
				this.$message({
					type: 'error',
					message: res.data.msg,
					duration: 5000
				});
				return;
			}
			this.$message.success("导入成功");
			this.diaIf = false;
			this.importOpen = false;
			this.initList();
		}else{
			this.$message.error('上传失败');
		}
    },
	handleUploadError(err) {
		this.$message.error(err);
	},
    // 导入弹窗
    fileAdd() {
      this.importOpen = true;
      this.title = "导入";
    },
    // 搜索重置
    resets() {
      this.searchForm = {
        building_id: this.$route.query.id,
        page: 1,
        size: 10,
        title: undefined,
        mobile: undefined,
      };
      this.initList();
    },
    // 重置
    reset() {
      this.form = {
        sms_status: undefined,
        title: undefined,
      };
    },
    // 新增弹窗
    handleNewAdd() {
      this.title = "新增";
      this.reset();
      this.handleAdd();
      this.form.sms_status = 1;
    },
    // 修改弹窗
    handleClick(row) {
      this.title = "修改";
      this.form = JSON.parse(JSON.stringify(row));
      const { city_name, created_at, share_img, ...rest } = row;
      this.form = rest;
      this.handleEdit();
    },
    // 关闭弹窗
    getout() {
      this.addOrEditOpen = false;
      this.$refs.form.clearValidate();
    },
    // 提交
    submitForms() {
      this.form.building_id = this.$route.query.id;
      this.submitForm();
    },
  },
};
</script>
<style scoped>
/deep/.el-table,
.el-table th,
.el-table td {
  border-radius: 10px;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-size: 16px;
  font-family: Times, "Times New Roman";
  /* font-weight: 600; */
}

.topNav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 20px 20px;
  border-radius: 10px;
}

.navFormWrapper {
  display: flex;
  align-items: center;
}
.upload-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/views/community/room.vue